// extracted by mini-css-extract-plugin
module.exports = {"resolutionXs":"768","resolutionSm":"992","resolutionMd":"1200","resolutionLg":"1400","resolutionMlg":"1700","resolutionXmlg":"1800","resolutionXlg":"2000","resolutionXxlg":"5000"};